import api from '../api';
import {
  BuildingsResponse,
  DeskResponse,
  FloorResponse,
  PlaceResponse,
  SectionResponse,
} from '../models';

const baseUrl = 'pwa/place/available';

export class PlaceService {
  public availablePlaces = (date: string) =>
    api.get<PlaceResponse[]>(`${baseUrl}/all?date=${date}`);

  public availableBuildings = (date: string) =>
    api.get<BuildingsResponse[]>(`${baseUrl}/building?date=${date}`);

  public availableFloor = (date: string, building_id: number) =>
    api.get<FloorResponse[]>(
      `${baseUrl}/floor?date=${date}&buildingId=${building_id}`
    );

  public availableSection = (
    date: string,
    building_id: number,
    floor: string
  ) =>
    api.get<SectionResponse[]>(
      `${baseUrl}/section?date=${date}&buildingId=${building_id}&floor=${floor}`
    );

  public availableDesk = (
    date: string,
    building_id: number,
    floor: string,
    section_id: number
  ) =>
    api.get<DeskResponse[]>(
      `${baseUrl}/desk?date=${date}&buildingId=${building_id}&floor=${floor}&section=${section_id}`
    );
}

const placeService = new PlaceService();
export default placeService;
